app.controller('sessionsCalendar', function ($scope, $http) {
    // Session list toggling logic
    let expandedPrograms = ['0']; // The top one always visible by default
    $scope.toggleSessionList = function (sessionId) {
        if ($scope.isSessionListExpanded(sessionId)) {
            expandedPrograms = expandedPrograms.filter(el => el !== sessionId);
        } else {
            expandedPrograms.push(sessionId);
        }
    };
    $scope.isSessionListExpanded = function (sessionId) {
        return expandedPrograms.includes(sessionId);
    };
});
